module.exports = __webpack_public_path__ + "static/media/background_bb.7c7e67d8.png";